import { useState } from "react";
import { Text, Button, Accordion, View } from "@aws-amplify/ui-react";

function TroubleHelp({ssid}) {
  const [open, setOpen] = useState(false);

  const listBase = {
    paddingLeft: "1.25rem",   // ~ml-5
    marginTop: "0.25rem",
    marginBottom: 0,
    color: "var(--amplify-colors-font-secondary)",
    fontSize: "0.875rem",     // ~text-sm
  };

  const liStyle = { marginTop: "0.25rem" };

  return (
    <View marginTop="0.75rem">
      <Button
        variation="link"
        size="small"
        onClick={() => setOpen((prev) => !prev)}
      >
        {open ? "Hide help" : "Having trouble?"}
      </Button>

      {open && (
        <View marginTop="0.5rem">
          <Accordion.Container>
            <Accordion.Item value="ssid-not-visible">
              <Accordion.Trigger>
                I don’t see {ssid} in my Wi-Fi networks
                <Accordion.Icon />
              </Accordion.Trigger>
              <Accordion.Content>
                <ul style={{ ...listBase, listStyleType: "disc" }}>
                  <li style={liStyle}>
                    Remove the batteries, wait 5 seconds, then repeat the Wi-Fi setup steps above.
                  </li>
                  <li style={liStyle}>
                    Move closer to the device.
                  </li>
                </ul>
              </Accordion.Content>
            </Accordion.Item>
            <Accordion.Item value="connected-no-page">
              <Accordion.Trigger>
                I connected to {ssid}, but nothing happened
                <Accordion.Icon />
              </Accordion.Trigger>
              <Accordion.Content>
                <View>
                  <Text fontSize="0.85rem" color="font.secondary">
                    If the setup page did not open automatically:
                  </Text>

                  <ol style={{ ...listBase, listStyleType: "decimal" }}>
                    <li style={liStyle}>
                      Stay connected to <code>{ssid}</code>.
                    </li>
                    <li style={liStyle}>
                      Open your browser and go to <code>http://192.168.4.1</code>.
                    </li>
                    <li style={liStyle}>
                      Enter the Wi-Fi name and password you want the device to use.
                    </li>
                  </ol>
                </View>
              </Accordion.Content>
            </Accordion.Item>
          </Accordion.Container>
        </View>
      )}
    </View>
  );
}

export default TroubleHelp;
